import React, { memo } from 'react';
import { makeStyles } from '@mui/styles';

import SimpleModal from '../../SimpleModal';
import Button from '../../Button';
import { VOID_ROUTE_WARNING, WARNING, OK } from '../../../constants/strings';
import { Text } from '../../Base';
import warningTextModal from '../../styles/warningTextModal';

const useStyles = makeStyles(() => warningTextModal);

const VoidRouteWarningModal = ({ open, onClose }) => {
  const classes = useStyles();

  return (
    <SimpleModal
      onClose={onClose}
      open={open}
      title={WARNING.toUpperCase()}
      actions={
        <>
          <Button minWidthZero onClick={onClose} className={classes.blueButton}>
            {OK}
          </Button>
        </>
      }
    >
      <Text className={classes.text}>{VOID_ROUTE_WARNING}</Text>
    </SimpleModal>
  );
};

export default memo(VoidRouteWarningModal);
